import React from "react";

export default function ColorFrame22({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <g clipPath="url(#clip0_2256_162033)">
          <path
            fill="#fff"
            stroke="#000"
            strokeWidth="1.937"
            d="M52.992 2.142H278.433V227.583H52.992z"
            transform="rotate(11.462 52.992 2.142)"
          ></path>
          <path
            fill="#fff"
            stroke="#000"
            strokeWidth="1.937"
            d="M32.187 29.215H252.36V249.388H32.187z"
            transform="rotate(.774 32.187 29.215)"
          ></path>
          <path
            fill="#000"
            d="M158.346 247.698a6.645 6.645 0 016.645-6.645h18.986a6.646 6.646 0 016.645 6.645v1.424c0 8.913-7.226 16.138-16.138 16.138-8.913 0-16.138-7.225-16.138-16.138v-1.424z"
          ></path>
          <path
            fill="#000"
            d="M183.561 266.17c0 .611-.496 1.107-1.107 1.107h-15.941a1.107 1.107 0 01-1.107-1.107 2.926 2.926 0 012.927-2.927h12.301a2.926 2.926 0 012.927 2.927z"
          ></path>
          <path
            fill="#fff"
            d="M168.224 258.495c-.853-1.152-1.906-3.508-2.587-5.883-.682-2.376-3.413-3.632-3.584-3.033-.243.847.661 4.754 1.659 6.58.998 1.825 2.752 3.414 3.753 3.906 1 .491 3.108.919 4.406.827-.87-.232-2.463-.798-3.647-2.397z"
          ></path>
          <path
            fill="#000"
            d="M202.905 225.723a9.247 9.247 0 01-.37 13.072l-3.176 3.002c-3.712 3.507-9.565 3.342-13.072-.37a2.498 2.498 0 01.1-3.533l12.985-12.271a2.5 2.5 0 013.533.1z"
          ></path>
          <path
            fill="#000"
            d="M202.539 238.347a2.471 2.471 0 11-3.593 3.395l-1.458-1.542a1.243 1.243 0 01.05-1.756l1.788-1.689a1.243 1.243 0 011.756.049l1.457 1.543z"
          ></path>
          <path
            fill="#fff"
            stroke="#000"
            strokeWidth="2.017"
            d="M116.749 265.177l18.383-8.465s4.787 2 12.385 5.895c7.599 3.895 16.413 9.018 16.413 9.018-4.028-3.124-7.69-4.365-26.963-18.036-1.183-.765.283-9.411-1.014-10.228-5.909-3.723-12.219-8.915-20.929-13.514.275 1.412.108 1.933-.271 2.495-1.14-.588-3.832-4.628-4.486-5.478-3.404-1.713-9.112-2.637-12.581-4.39-8.424-4.258-18.408-10.219-27.582-13.685-.379.563 1.675 3.583 1.858 4.524-4.407-2.562-5.428-5.294-5.705-6.218-10.657-3.389-16.078-6.729-28.558-6.654-18.218.109-38.492 23.129-32.11 25.795 10.86 4.536 17.392 7.362 19.577 9.38 1.302 1.202 2.668 2.738 4.998 3.917 3.02-2.058 9.897-4.374 14.317-4.258-.326.251-3.019 1.279-4.432 2.333-2.273 1.697-3.531 3.615-3.531 3.615s14.912-1.598 23.172-.603c.809-.864 8.107-3.533 10.356-2.016-2.42.115-7.257 2.878-7.257 2.878s2.945.158 4.512.588c6.67 1.633 12.89 8.427 18.192 10.626.38-.562 4.916-4.865 8.394-4.565 0 0-1.32.745-2.55 1.962-1.228 1.216-1.516 2.249-1.516 2.249 3.295-.641 8.341-2.166 9.977-1.454-5.557 1.571-6.982 4.291-6.982 4.291 6.988 3.063 20.207 7.443 23.933 9.998z"
          ></path>
          <path
            fill="#1E499A"
            fillOpacity="0.33"
            d="M5.59 226.236c10.859 4.536 17.39 7.362 19.576 9.38 1.302 1.202 2.668 2.738 4.998 3.917 3.02-2.058 9.897-4.374 14.317-4.258-.326.251-3.019 1.279-4.432 2.333-2.273 1.697-2.837 2.991-2.837 2.991 14.88-3.874 14.805-8.315 22.161-11.643 7.32-3.312 12.164-4.079 16.11-5.091.465-.119-.395-8.717-1.625-13.364l-3.754-1.712c-.379.563 1.675 3.583 1.858 4.524-4.407-2.562-5.428-5.294-5.705-6.218-10.657-3.389-16.078-6.729-28.558-6.654-18.218.109-38.492 23.129-32.11 25.795z"
          ></path>
          <path
            fill="#000"
            d="M131.862 252.463c-8.705-2.926-20.06-7.285-30.406-13.135-6.472-3.658-9.643-5.732-16.505-9.489-4.45-2.437-11.156-7.111-23.645-11.031-3.928-1.233-8.881-2-13.674-2.48-10.444-1.044-20.125-.722-16.782-.873 6.68-.302 12.773-.239 18.621.283 5.6.5 10.929 1.388 18.413 4.232 9.497 3.61 25.75 14.237 39.392 21.646 9.124 4.955 17.079 7.423 24.586 10.847z"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_2256_162033">
            <path
              fill="#fff"
              d="M0 0H276V276H0z"
              transform="translate(0 .067)"
            ></path>
          </clipPath>
        </defs>
        {children}
      </g>
    </svg>
  );
}
